import { UserMenu, MenuItemLink  } from 'react-admin';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AccountBoxIcon from '@material-ui/icons/AccountBox';

import { useAuth0 } from '@auth0/auth0-react';

const SignOutMenu = () => {

    const { logout } = useAuth0();
    function handleOnClick(e) {
        logout({          
            returnTo: window.location.origin,
        })
    }
    return (
        <MenuItemLink
            to="/"
            primaryText="Sign Out"
            leftIcon={<ExitToAppIcon />}
            onClick={handleOnClick} // close the menu on click
        />
    )
};

export const MyUserMenu = props => (   
    <UserMenu {...props} logout={null} > 
        <MenuItemLink
            to="/userprofile"
            primaryText="Your Profile"
            leftIcon={<AccountBoxIcon />}
        />
        <MenuItemLink
            to="/settings"
            primaryText="Settings"
            leftIcon={<SettingsIcon />}
        />
        <SignOutMenu />
    </UserMenu>
);
